export enum GlobalFieldCreationSource {
  FIELD_PICKER = 'field_picker',
  SETTINGS = 'settings',
}
